<template>
  <div class="card card-graph flex-fill w-100">
    <div class="card-header">
      <h3 class="card-title mb-0">{{ title }}</h3>
    </div>
    <div class="card-body d-flex">
      <div class="graph flex-grow-1 d-flex flex-col justify-content-center">
        <div class="d-flex flex-column justify-content-center" ref="charRef" style="height: 100%; width: 100%">
          <div class="uptime" :class="{ 'no-data': !hasData }">{{ uptimeStr }}</div>
          <div v-if="hasData" class="hourStr">{{ hourStr }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 1024px) {
}

.graph {
  min-height: 160px;
  width: 100%;
  align-items: center;
  font-size: 28px;
}
.graph div div.uptime {
  text-align: center;
  font-weight: bold;
  color: #73bf69;
  padding: 10px;
}
.graph div div.hourStr {
  text-align: center;
  font-size: 60%;
}
.graph div div.uptime.no-data {
  color: #8b949e;
  font-size: 14px;
  font-weight: 500;
}
</style>

<script>
import { onMounted, onUnmounted, onBeforeMount, onBeforeUnmount, ref, computed } from 'vue'
import axios from 'axios'
import { useStore } from 'vuex'
import { createQuery } from '@/data/createUpQuery'
import { NO_DATA_AVAILABLE } from '@/data/chartEmptyState'

export default {
  name: 'Uptime',
  props: {
    host: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    refresh: {
      type: Number,
      default: 15,
    },
    title: {
      type: String,
      default: 'Uptime',
      rquired: false,
    },
  },
  setup(props) {
    //const orgID = '1b0f79e17233c082'
    const timer = ref(null)

    const charRef = ref(null)
    const txtTitle = ref(null)

    const store = useStore()

    const apiKey = computed(() => store.state.auth.user?.accessToken)
    const apiHost = computed(() => window.apiHost)
    //const apiOrgId = computed(() => store.state.config.apiOrgId);

    const uptimeStr = ref(NO_DATA_AVAILABLE)
    const hourStr = ref('')
    const hasData = ref(false)

    const resizeObserver = new ResizeObserver(() => {
      onWindowResize()
    })

    async function main() {
      try {
        const query = createQuery(props.host, props.type)
        const response = await axios.post(apiHost.value + '/core/api/v1/analytics/query', query, {
          headers: {
            Authorization: 'Bearer ' + apiKey.value,
            'Content-Type': 'application/vnd.flux',
            Accept: 'application/csv',
          },
        })
        var data = response.data
        var lines = -1
        var value = 0
        data.split('\n').forEach((line) => {
          if (++lines == 1) {
            var fields = line.trim().split(',')
            value = fields[6]
            return
          }
        })

        setUptimeStr(value)
      } catch (error) {
        console.error(error)
        setUptimeStr(null)
      }
    }

    function onWindowResize() {
      //console.log("resizing..")
    }

    function setUptimeStr(rawSeconds) {
      const uptimeSeconds = Number(rawSeconds)
      hasData.value = rawSeconds !== null && rawSeconds !== undefined && rawSeconds !== '' && !Number.isNaN(uptimeSeconds)

      if (!hasData.value) {
        uptimeStr.value = NO_DATA_AVAILABLE
        hourStr.value = ''
        return
      }

      if (uptimeSeconds < 60) {
        uptimeStr.value = uptimeSeconds + ' Seconds'
      } else if (uptimeSeconds < 3600) {
        const minutes = Math.floor(uptimeSeconds / 60)
        uptimeStr.value = minutes + ' Minute' + (minutes > 1 ? 's' : '')
      } else if (uptimeSeconds < 86400) {
        const hours = Math.floor(uptimeSeconds / 3600)
        uptimeStr.value = hours + ' Hour' + (hours > 1 ? 's' : '')
      } else if (uptimeSeconds < 2592000) {
        const days = Math.floor(uptimeSeconds / 86400)
        uptimeStr.value = days + ' Day' + (days > 1 ? 's' : '')
      } else if (uptimeSeconds < 31536000) {
        const months = Math.floor(uptimeSeconds / 2592000)
        uptimeStr.value = months + ' Month' + (months > 1 ? 's' : '')
      } else {
        const years = Math.floor(uptimeSeconds / 31536000)
        uptimeStr.value = years + ' Year' + (years > 1 ? 's' : '')
      }

      hourStr.value = uptimeSeconds > 86400 ? '(' + Math.floor(uptimeSeconds / 3600) + ' Hrs)' : ''
    }

    onMounted(() => {
      main()

      if (props.refresh > 0) {
        timer.value = setInterval(() => {
          //main();
        }, props.refresh * 1000)
      }
    })

    onUnmounted(() => {
      if (props.refresh > 0 && timer.value !== null) {
        clearInterval(timer.value)
      }
    })

    onBeforeMount(() => {
      window.addEventListener('resize', onWindowResize)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', onWindowResize)
      resizeObserver.unobserve(charRef.value)
    })

    return {
      charRef,
      txtTitle,
      uptimeStr,
      hourStr,
      hasData,
    }
  },
}
</script>
